import { FormProvider } from 'react-hook-form';
import { useEditClientContractTerm } from './hooks';
import { convertToPresentationProps } from './logics';
import { EditClientContractTermPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 編集 Container コンポーネント
 *
 * ## 構成
 * - 本体表示（読み取り項目・フォーム要素配置・Zod スキーマの骨格）: T03（PEN-980）で実装済み
 * - バリデーションルール詳細・API 送信処理: T04（PEN-981）で実装済み
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 */
export const EditClientContractTerm: React.FC<Props> = ({ clientId, termId }) => {
  const {
    state: { data, contractPlansData, methods, isSaving },
    actions: { handleSubmit, handleCancel },
  } = useEditClientContractTerm({ clientId, termId });

  const {
    clientName,
    contractPlanName,
    kindBadge,
    giftPlan,
    customerChargeUnitPrice,
    taxRatePercent,
    contractPlanOptions,
    isStartedOnDisabled,
    isContractPlanDisabled,
    endedOnFromDate,
  } = convertToPresentationProps({ data, contractPlansData });

  return (
    <FormProvider {...methods}>
      <EditClientContractTermPresentation
        clientName={clientName}
        contractPlanName={contractPlanName}
        kindBadge={kindBadge}
        giftPlan={giftPlan}
        customerChargeUnitPrice={customerChargeUnitPrice}
        taxRatePercent={taxRatePercent}
        contractPlanOptions={contractPlanOptions}
        isStartedOnDisabled={isStartedOnDisabled}
        isContractPlanDisabled={isContractPlanDisabled}
        endedOnFromDate={endedOnFromDate}
        isButtonDisabled={isSaving}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </FormProvider>
  );
};
